import React from 'react';

// styles
import {
    StepContainer,
    StepIndicator,
    StepHeader,
    StepTitle,
    StepDescription,
    ShowcaseContainer,
    ShowcaseGif
} from './StepTwo.styles.js';

// assets
import showcaseGif from '../../../../assets/landing/showcase.gif';

export default function StepTwo() {
    return (
        <StepContainer>
            <StepIndicator>2</StepIndicator>
            <StepHeader>
                <StepTitle>Build your showcase</StepTitle>
                <StepDescription>Upload images & share your hits</StepDescription>
            </StepHeader>
            <ShowcaseContainer>
                <ShowcaseGif src={showcaseGif} alt="Showcase demo" />
            </ShowcaseContainer>
        </StepContainer>
    );
}
